jQuery(document).ready(function($) {
	$('body').addClass('ready');
	// Contact Form 7
	// Fade out errors after interaction
	$('.wpcf7-form-control').on('click', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});
	$('.wpcf7-form-control').on('input', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});
	$('.wpcf7-form-control').on('change', function() {
		$(this).closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').fadeOut();
	});
});